import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CustomCompanyService } from './company.service';
import { CompaniesService } from '../api/companies.service';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AppOptionsService {

  // Fallback hardcodeado en caso de que la API no responda
  private readonly defaultLanguages = [
    { code: 'es', name: 'Español' },
    { code: 'en', name: 'English' },
    { code: 'pt', name: 'Português' },
    { code: 'ca', name: 'Català' },
    { code: 'fr', name: 'Français' },
    { code: 'de', name: 'Deutsch' },
    { code: 'it', name: 'Italiano' },
    { code: 'zh', name: '中文' }
  ];

  private cachedLanguages: { code: string, name: string }[] | null = null;

  constructor(
    public translate: TranslateService,
    private companyService: CustomCompanyService,
    private companiesService: CompaniesService
  ) {
  }

  readonly profiles = [

    { name: 'COMMON.PROFILES.QUALITY', code: 1 },
    { name: 'COMMON.PROFILES.MARKETING', code: 2 },
    { name: 'COMMON.PROFILES.SALES', code: 3 },
    { name: 'COMMON.PROFILES.SUPPORT', code: 4 },
    { name: 'COMMON.PROFILES.LOGISTICS', code: 5 },
    { name: 'COMMON.PROFILES.REGULATORY', code: 6 },
    { name: 'COMMON.PROFILES.TRANSLATION', code: 7 },
    { name: 'COMMON.PROFILES.DATAENTRY', code: 8 },
    { name: 'COMMON.PROFILES.LABORATORY', code: 9 },
    { name: 'COMMON.PROFILES.DESIGN', code: 10 },
    { name: 'COMMON.PROFILES.OTHER', code: 0 },
  ];

  getLanguages(): Observable<{ code: string, name: string }[]> {
    // Si ya tenemos los idiomas cacheados, devolverlos
    if (this.cachedLanguages) {
      return of(this.cachedLanguages);
    }

    // Obtener idiomas desde la API (ya vienen con nombres del backend)
    return this.companiesService.companiesGetLanguages().pipe(
      map((apiLanguages: any[]) => {
        // Filtrar solo idiomas habilitados para el frontend y mapear
        const languages = apiLanguages
          .filter((lang: any) => lang.isEnabledForFrontend === true)
          .map((lang: any) => ({
            code: lang.code?.toLowerCase() || lang.code,
            name: lang.name || lang.code // El nombre ya viene del backend
          }));
        // Cachear los idiomas
        this.cachedLanguages = languages;
        return languages;
      }),
      catchError((error) => {
        console.warn('Error obteniendo idiomas de la API, usando fallback', error);
        return of(this.defaultLanguages);
      })
    );
  }

  getProfiles(): { name: string, code: number }[] {
    return this.profiles;
  }

}
